import React, { Component } from 'react';

export default class Footnotes extends Component {
    render() {
        return (<div>
            <h5>Footnotes</h5>
            <sup>1</sup> For further examples refer to AS 4970-2009, Appendix A, Figure A1. <br />
            <sup>2</sup> For further examples refer to AS 4970-2009, Appendix D, Figure D1.
        </div>
        );
    }
}